var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c(
        "keep-alive",
        [_vm.$route.meta.keepAlive ? _c("router-view") : _vm._e()],
        1
      ),
      _vm._v(" "),
      !_vm.$route.meta.keepAlive ? _c("router-view") : _vm._e(),
      _vm._v(" "),
      _vm.$route.meta.isshowtabbar ? _c("v-tab-bar", { ref: "bar" }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }